/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, Input, OnInit } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenuItem } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { LogoutService } from './logout.service';

@Component({
    selector: 'dash-gis-logout',
    templateUrl: './logout.component.html',
    imports: [MatMenuItem, MatIcon, MatIconButton, MatTooltip, MatButton],
})
export class LogoutComponent implements OnInit {
    @Input() showIcon = false;
    @Input() inMenu = false;

    constructor(private logoutService: LogoutService) {}

    ngOnInit() {}

    public showLogout() {
        this.logoutService.doLogout();
    }
}
